<template>
    <div class="p-menu">
        <h5 class="text-center">Block Information</h5>
        <Divider />
        <div v-if="builderStore.activeBlock">
            <TabView v-model:activeIndex="activePanel">
                <TabPanel header="Step Details">
                    <step-config-panel />
                </TabPanel>
                <TabPanel header="Step Pass Config">
                    <pass-fail-config />
                </TabPanel>
                <TabPanel header="Block Details">
                    <block-details-panel :block="builderStore.activeBlock" />
                </TabPanel>
            </TabView>
        </div>
        <div v-else>Selected active block detailed information will be shown here</div>
    </div>
</template>

<script setup>
import { ref, inject, watch } from 'vue';
import { storeToRefs } from 'pinia';
import BlockDetailsPanel from '../../block/components/BlockDetailsPanel.vue';
import StepConfigPanel from '../modules/step/components/StepConfigPanel.vue';
import PassFailConfig from '../modules/step/modules/outcome/views/PassFailConfig.vue';

const builderStore = inject('builderStore');
const activePanel = ref(0);
const stepStore = inject('stepStore');
const { loadingStep } = storeToRefs(stepStore);

watch(loadingStep, () => {
    // if step is being loaded, switch tab
    if (loadingStep.value) {
        activePanel.value = 0;
    }
});
</script>
